import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const StartSessionModalSubtitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "20px",
  color: colors.text.secondary,
  textAlign: "center",
  marginTop: "12px",
  marginBottom: "32px",
});

export const SessionTypeLabel = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  color: colors.text.primary,
  textAlign: "center",
  margin: "24px 0",
});

export const StartSessionModalActions = styled(Box)({
  display: "flex",
  gap: "16px",
  marginTop: "32px",
  justifyContent: "center",
  "& button": {
    minWidth: "120px",
    height: "48px",
    fontSize: "16px",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "8px",
  },
  "& button[type='submit']": {
    backgroundColor: colors.amber.main,
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: colors.amber.dark,
    },
  },
});

export const SessionTypeToggleContainer = styled(Box)({
  display: "flex",
  gap: "40px",
  justifyContent: "center",
  marginBottom: "24px",
});

interface SessionTypeOptionProps {
  selected: boolean;
}

export const SessionTypeOption = styled(Box)<SessionTypeOptionProps>(
  ({ selected }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "24px",
    padding: "32px 60px",
    borderRadius: "16px",
    border: `2px solid ${selected ? colors.primary.main : colors.border.light}`,
    backgroundColor: selected
      ? colors.background.secondary
      : "rgba(58, 138, 185, 0.08)",
    color: colors.text.primary,
    fontSize: "18px",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "24px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    minWidth: "200px",
  })
);
